import React from 'react';
import { LayoutGrid, Wallet, CreditCard, TrendingUp, Folder, Users, Bell, Settings, MessageSquare, Laptop } from 'lucide-react';
export function Sidebar() {
  const navItems = [{
    icon: LayoutGrid,
    active: false
  }, {
    icon: Wallet,
    active: false
  }, {
    icon: CreditCard,
    active: true
  }, {
    icon: TrendingUp,
    active: false
  }, {
    icon: Folder,
    active: false
  }, {
    icon: Users,
    active: false
  }, {
    icon: Bell,
    active: false
  }];
  const bottomItems = [{
    icon: Settings,
    active: false
  }, {
    icon: MessageSquare,
    active: false
  }, {
    icon: Laptop,
    active: false
  }];
  return <aside className="fixed left-0 top-0 h-screen w-[60px] bg-[#141414] border-r border-[#252525] flex flex-col items-center py-6 z-50" data-id="element-62">
      {/* Profile Avatar */}
      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center text-xs font-semibold text-black mb-8" data-id="element-63">
        VU
      </div>

      {/* Main Navigation */}
      <nav className="flex-1 flex flex-col gap-4" data-id="element-64">
        {navItems.map((item, index) => {
        const Icon = item.icon;
        return <button key={index} className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-200 ${item.active ? 'bg-orange-500 text-black shadow-lg shadow-orange-500/20' : 'text-gray-400 hover:text-white hover:bg-[#1a1a1a]'}`} data-id="element-65">
              <Icon size={20} data-id="element-66" />
            </button>;
      })}
      </nav>

      {/* Bottom Navigation */}
      <div className="flex flex-col gap-4" data-id="element-67">
        {bottomItems.map((item, index) => {
        const Icon = item.icon;
        return <button key={index} className="w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#1a1a1a] transition-all duration-200" data-id="element-68">
              <Icon size={20} data-id="element-69" />
            </button>;
      })}
      </div>
    </aside>;
}